import styled from 'styled-components';
import { media } from '@core/styles/breakpoints';
import { spaces } from '@engage/styles/spaces';
import Toast from './Toast';

export const StandardToast = styled(Toast)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  ${media.tablet`
    top: ${spaces.huge}px;
    width: 360px;
  `}
`;
